import { GbsState, GbsStep, InitialQuoteInformation } from './interfaces'

export enum Actions {
  InitializeStep = 'INITIALIZE_STEP',
  SetCurrentStep = 'SET_CURRENT_STEP',
  SetStepData = 'SET_STEP_DATA',
  SetInitialQuoteInformation = 'SET_INITIAL_INFORMATION',
  SetBottomBarEdit = 'SET_BOTTOM_BAR_EDIT',
  SetZipCode = 'SET_ZIP_CODE'
}

export interface InitializeStep {
  type: Actions.InitializeStep
  payload: {
    stepKey: keyof GbsState['steps']
    stepConfig: Omit<GbsStep, 'data'>
  }
}

export interface SetInitialQuoteInformation {
  type: Actions.SetInitialQuoteInformation
  payload: Partial<InitialQuoteInformation>
}

export interface SetCurrentStep {
  type: Actions.SetCurrentStep
  payload: keyof GbsState['steps']
}

export interface SetStepData<T = any> {
  type: Actions.SetStepData
  payload: {
    stepKey: keyof GbsState['steps']
    stepData: T
  }
}

export interface SetBottomBarEdit {
  type: Actions.SetBottomBarEdit
  payload: boolean
}

export interface SetZipCode {
  type: Actions.SetZipCode
  payload: string
}

export type GbsAction =
  | InitializeStep
  | SetCurrentStep
  | SetStepData
  | SetInitialQuoteInformation
  | SetBottomBarEdit
  | SetZipCode
